(function () {
    'use strict';

angular.module('AngularAdmin')

.directive('pdDatepickerToggle', [function ($datepicker) { 
    function link(scope, element, attrs, ngModelController) {
    	element.on('click', function(){
    		$(element.data('toggle')).focus();
    	});
    }
    return {
        link: link
    };
}]);

})();